module.exports = __webpack_public_path__ + "static/media/peeking_doodle.769fa646.svg";